var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "location_payment" }, [
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "payment_online" } },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.__t("PAY_TYPE_ONLINE")) + "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.payments.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    id: "payment_online",
                    reduce: function (payment) {
                      return payment.id
                    },
                    label: "title",
                    options: this.payments,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.title) +
                                  "\n                        "
                              ),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.uniq_id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2790932360
                  ),
                  model: {
                    value: _vm.location.payment_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.location, "payment_id", $$v)
                    },
                    expression: "location.payment_id",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v(
                      "\n                    Оберіть оплату\n                "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group mt-2" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "payment_cache" } },
        [
          _vm._v(
            "\n            " + _vm._s(_vm.__t("PAY_TYPE_CACHE")) + "\n        "
          ),
        ]
      ),
      _vm._v(" "),
      _vm.payments.length > 0
        ? _c(
            "div",
            {},
            [
              _c(
                "v-select",
                {
                  staticClass: "imc_reasons",
                  attrs: {
                    id: "payment_cache",
                    label: "title",
                    reduce: function (payment) {
                      return payment.id
                    },
                    options: this.payments,
                    filterable: false,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.title) +
                                  "\n                        "
                              ),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(option.uniq_id) +
                                      "\n                            "
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2790932360
                  ),
                  model: {
                    value: _vm.location.pay_cache,
                    callback: function ($$v) {
                      _vm.$set(_vm.location, "pay_cache", $$v)
                    },
                    expression: "location.pay_cache",
                  },
                },
                [
                  _c("template", { slot: "no-options" }, [
                    _vm._v(
                      "\n                    Оберіть оплату\n                "
                    ),
                  ]),
                ],
                2
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.show_bonus
      ? _c("div", { staticClass: "form-group mt-2" }, [
          _c(
            "label",
            { staticClass: "form-label", attrs: { for: "payment_cache" } },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.__t("PAY_BONUS")) + "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _vm.payments.length > 0
            ? _c(
                "div",
                {},
                [
                  _c(
                    "v-select",
                    {
                      staticClass: "imc_reasons",
                      attrs: {
                        id: "payment_cache",
                        label: "title",
                        reduce: function (payment) {
                          return payment.id
                        },
                        options: this.payments,
                        filterable: false,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "option",
                            fn: function (option) {
                              return [
                                _c("div", { staticClass: "d-center" }, [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(option.title) +
                                      "\n                        "
                                  ),
                                  _c("div", [
                                    _c("small", [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(option.uniq_id) +
                                          "\n                            "
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2790932360
                      ),
                      model: {
                        value: _vm.location.general_fields.bonus_payment,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.location.general_fields,
                            "bonus_payment",
                            $$v
                          )
                        },
                        expression: "location.general_fields.bonus_payment",
                      },
                    },
                    [
                      _c("template", { slot: "no-options" }, [
                        _vm._v(
                          "\n                    Оберіть оплату\n                "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }